export default "__VITE_ASSET__I9lECJ6W__"